<template>
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <router-link :to="home">
        <h3 class="p-0 m-0">
          <i class="fa fa-home"></i>
        </h3>
      </router-link>
    </li>
    <li
      v-for="(breadcrumb, index) in breadcrumbs"
      :key="index"
      class="breadcrumb-item active d-flex align-items-center"
    >
      <router-link
        v-if="index + 1 !== breadcrumbs.length && breadcrumb.routeTo"
        :to="breadcrumb.routeTo"
      >
        {{ breadcrumb.title }}
      </router-link>
      <span v-else>
        {{ breadcrumb.title }}
      </span>
    </li>
  </ol>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Breadcrumbs',
  props: {
    homeRoute: {
      required: false,
      type: Object,
    },
    breadcrumbs: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['user', 'org']),
    home() {
      if (this.homeRoute) {
        return this.homeRoute;
      }

      if (this.user.isAuthenticated) {
        return { name: 'dashboard' };
      }

      return { name: 'home' };
    },
  },
};
</script>
